export function addCountries(data) {
    return async dispatch => {
        dispatch({
            type: "ADD_COUNTRIES",
            data: data
        });
    };
}
